import { render, staticRenderFns } from "./EditAttributeGroupComponent.vue?vue&type=template&id=e38b0d2a&scoped=true"
import script from "./EditAttributeGroupComponent.vue?vue&type=script&lang=js"
export * from "./EditAttributeGroupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38b0d2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e38b0d2a')) {
      api.createRecord('e38b0d2a', component.options)
    } else {
      api.reload('e38b0d2a', component.options)
    }
    module.hot.accept("./EditAttributeGroupComponent.vue?vue&type=template&id=e38b0d2a&scoped=true", function () {
      api.rerender('e38b0d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/components/EditAttributeGroupComponent.vue"
export default component.exports